module.exports = __webpack_public_path__ + "img/provider4.ae0821d3.png";